import OSS from 'ali-oss';
import apis from '../api/apis'
import store from "../store" // 引入vuex
import base from '../api/config'
import heic2any from 'heic2any'; // 导入heic2any 库

var client
var data
var schedule // 进度
export function createClient(file) {
  // console.log(file);
  if (file.file.name.indexOf('HEIC') !== -1 || file.file.name.indexOf('heic') !== -1) {
    return heic2jpeg(file)
  } else {
    return createOss(file)
  }
}
function createOss(file) {
  return new Promise((resolve, reject) => {
    let url = location.href
    apis.getUploadToken({ url }).then(async res => {
      data = res.data
      client = new OSS({
        // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
        region: 'oss-cn-hangzhou',
        // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
        accessKeyId: data.AccessKeyId,
        accessKeySecret: data.AccessKeySecret,
        // 从STS服务获取的安全令牌（SecurityToken）。
        stsToken: data.SecurityToken,
        // 刷新临时访问凭证的时间间隔，单位为毫秒。
        refreshSTSTokenInterval: 300000,
        // 填写Bucket名称。
        bucket: 'raku-ai'
      });
      let url = ossUp(file)

      try {
        // 分片上传。
        const result = await client.multipartUpload(url, file.file, {
          progress,
        });
        let requestUrls = result.res.requestUrls[0].split('?')

        // console.log(requestUrls);

        if (requestUrls.length > 1) {
          resolve({ data: requestUrls[0] });
        } else {
          resolve({ data: requestUrls[0] });
        }
        // return result
        // 填写Object完整路径，例如exampledir/exampleobject.txt。Object完整路径中不能包含Bucket名称。
        // const head = await client.head(url);
        // console.log(head);
      } catch (err) {
        console.log(err);
      }
    })
  })
}
// 随机三位数
function mathNum() {
  var num = '';
  for (var i = 0; i < 6; i++) {
    num += Math.floor(Math.random() * 10);
  }
  return num
}

// 上传转换参数
export function ossUp(file) {
  var now = new Date()
  var year = now.getFullYear();  //取得4位数的年份
  var month = now.getMonth() + 1;  //取得日期中的月份，其中0表示1月，11表示12月
  if (month < 10) {
    month = '0' + month
  }
  let time = year + '' + month
  let name = file.file.name
  // console.log(name);

  return `/rakumart_pc/${time}/${mathNum()}/${name}`
}


const progress = (p, _checkpoint) => {
  schedule = (p * 100).toFixed(0)
  store.commit('setSchedule', schedule - 0)
  // Object的上传进度。
  // console.log(schedule);
  // 分片上传的断点信息。
  // console.log(_checkpoint);
};
// heic转jpeg
async function heic2jpeg(file) {
  // // 转换 HEIC 文件为 JPG
  const blobArray = await heic2any({
    blob: file.file,
    toType: "image/jpeg", // 转换为 JPG 格式
  });
  const files = new File([blobArray], file.file.name.split('.')[0] + '.jpg', { type: blobArray.type });
  return createOss({ file: files })



  // // 创建下载链接
  // const jpgBlob = new Blob(blobArray, { type: "image/jpeg" });
  // console.log(jpgBlob);

  // // } catch (error) {
  // //   console.error("HEIC 转换失败:", error);
  // //   alert("转换失败，请重试");
  // // }

  let formData = new FormData();

  formData.append("file", file, file.name); //传文件的时候result.name需要传一下,否则可能没有后缀名
  //文件上传请求
  var xhr = new XMLHttpRequest();

  xhr.open("POST", base.baseURL + "/api/common/docker/heic2jpeg", true);
  xhr.setRequestHeader(
    "Admintoken",
    "Bearer " + localStorage.getItem("japan_access_token")
  );
  xhr.onload = () => {
    if (xhr.status === 200) {

      console.log(xhr.response);

      // const res = JSON.parse(xhr.response);
      // this.handleAvatarSuccess(res);
    } else {
      // console.log("An error occurred while uploading the file.");
    }
  };
  xhr.send(formData);
}





